import * as React from 'react';
import { Responsive, Section, Box } from '@origin-digital/layout';
import { Card } from '@origin-digital/layout';
import { Heading3, Heading4, Text, Helpers, Metrics } from '@origin-digital/style-guide';
import styled from 'styled-components';

import { ResponsiveLayout } from '../../components/ResponsiveLayout';
import DateRangeIcon from '../../components/Icons/DateRangeIcon';
import BuildIcon from '../../components/Icons/BuildIcon';
import WbSunnyIcon from '../../components/Icons/WbSunnyIcon';

export type FooterContentProps = {
  data: {
    heading: string;
    disclaimer?: string;
    cards: {
      heading: string;
      text: string;
      iconType: string;
    }[];
  };
};

const HeaderWithIcon = styled(Box)`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  ${Helpers.media.LG`
    display: block;
  `};
`;

const LargeIcon = styled(Box)`
  display: none;
  ${Helpers.media.LG`
    display: block;
    margin-bottom: ${Metrics.Spacing.M_X_SM}px;
  `};
`;

const SmallIcon = styled(Box)`
  margin-top: -${Metrics.Spacing.M_Y_XXS / 2}px;
  ${Helpers.media.LG`
    display: none;
  `};
`;

export const getIcon = (type: string, size: number) => {
  switch (type) {
    case 'date-range':
      return <DateRangeIcon size={size} />;
    case 'sunny':
      return <WbSunnyIcon size={size} />;
    case 'build':
      return <BuildIcon size={size} />;
    default:
      return;
  }
};

const FooterContent: React.StatelessComponent<FooterContentProps> = ({ data }): JSX.Element => {
  return (
    <Section backgroundColor="white">
      <ResponsiveLayout min={['LG', 'XL']}>
        <Heading3 align="center" text={data.heading} />
        <Responsive breakpoint={'LG'} layoutSize="compact">
          {data.cards.map(card => {
            return (
              <Card key={card.text}>
                <HeaderWithIcon>
                  <LargeIcon>{getIcon(card.iconType, 46)}</LargeIcon>
                  <SmallIcon>{getIcon(card.iconType, 32)}</SmallIcon>
                  <Heading4 text={card.heading} marginBottom={true} />
                </HeaderWithIcon>
                <Text size="sm">{card.text}</Text>
              </Card>
            );
          })}
        </Responsive>
        <Card>
          <Text overflow="normal" size="xs" color="grey80">
            {data.disclaimer}
          </Text>
        </Card>
      </ResponsiveLayout>
    </Section>
  );
};

export { FooterContent as default };
